import { render, staticRenderFns } from "./CashRelief.vue?vue&type=template&id=06f3a895&"
import script from "./CashRelief.vue?vue&type=script&lang=js&"
export * from "./CashRelief.vue?vue&type=script&lang=js&"
import style0 from "./CashRelief.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports